import {focusBlock} from '../highlight.jsx';
import event, {EVENTS} from '../../lib/event';
import {useTouchInteraction, onClick} from '../utils';
import Audio from '../../lib/audio.js';
import Cartoon from '../avatar-action';
import {selectElement} from "../../lib/utils";
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';
import showOptions from './show-options';
import focusElement from './focus-element';

/**
 * 聚焦到某个元素，点击任意位置进入下一步
 * @param {number} index - 当element为string类型的selector时，表示第几个匹配
 * @param {left, top, width, height} args.sourceOffset - 相对于舞台区虚拟坐标的偏移量
 * @param {number} args.zIndex - 设置 z-index，默认值为 999
 * @param {string} tips - 提示，默认为`点击这里`
 * @param {string} pointerEvents - 焦点透传鼠标事件的属性，默认为auto
 * @param options - 选择题选项
 * @returns {Promise} 执行成功的 Promise，这个方法不可能失败
 */
export default function focusStage ({index, zIndex, offset, tips, pointerEvents, options}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    const _element = "[class^='stage_stage_']";
    if (!tips) {
        tips = "观察舞台区";
    }
    return focusElement({element: _element, index, zIndex, offset, tips, pointerEvents, options}, mode, _index);
    /*
    if (mode) {
        if (mode === BATCH_TIPS_MODE) {
            window.stepsRuntime.insertTips(_index, tips, true);
            return new Promise(resolve => {
                resolve();
            })
        }
    }else {
        Audio.tts(tips);
    }
    return new Promise(async (resolve, reject) => {
        event.once(EVENTS.STEP_ABORT, ()=>reject('Step Abort'));
        let element = await selectElement(_element, index);
        if (element) {
            focusBlock({source: element, sourceOffset: offset, tips, zIndex, pointerEvents: pointerEvents || 'auto', reject});
            if (options) { //有选项
                showOptions({tips, options}, mode, _index).then(arg => {
                    event.emit(EVENTS.CLEAR_COVER);
                    resolve(arg);
                }, reject);
            }else {
                if (mode) {
                    window.stepsRuntime.insertTips(_index, tips, true);
                }
                event.once(EVENTS.BG_CLICK, () => {
                    event.emit(EVENTS.CLEAR_COVER);
                    resolve(true);
                });
            }
        } else {
            window.stepsRuntime.insertTips(_index, tips, true);
            reject();
            console.warn(`element 未找到`);
        }
    });

     */
}
